import jsSHA from 'jssha';

export default {
  sha1(text) {
    const shaObj = new jsSHA('SHA-1', 'TEXT', {encoding: 'UTF8'});
    shaObj.update(text);
    return shaObj.getHash('HEX');
  },
  sha256(text) {
    const shaObj = new jsSHA('SHA-256', 'TEXT', {encoding: 'UTF8'});
    shaObj.update(text);
    return shaObj.getHash('HEX');
  }
}
